module.exports = __webpack_public_path__ + "static/media/21ECLAC47.dd1e3523.jpg";